<script setup>
import Button from 'dashboard/components-next/button/Button.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { computed } from 'vue';
import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';

const { updateUISettings } = useUISettings();

const { uiSettings } = useUISettings();
const isContactSidebarOpen = computed(
  () => uiSettings.value.is_contact_sidebar_open
);

const toggleConversationSidebarToggle = () => {
  updateUISettings({
    is_contact_sidebar_open: !isContactSidebarOpen.value,
    is_copilot_panel_open: false,
  });
};

const keyboardEvents = {
  'Alt+KeyO': {
    action: toggleConversationSidebarToggle,
  },
};
useKeyboardEvents(keyboardEvents);
</script>

<template>
  <Button
    v-tooltip.top="$t('CONVERSATION.SIDEBAR.CONTACT')"
    :aria-label="$t('CONVERSATION.SIDEBAR.CONTACT_INFO_BUTTON')"
    :aria-pressed="isContactSidebarOpen"
    size="sm"
    variant="ghost"
    color="slate"
    class="rounded-md"
    :class="{ 'bg-n-alpha-2': isContactSidebarOpen }"
    icon="i-lucide-contact-round"
    @click="toggleConversationSidebarToggle"
  />
</template>
